import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'content', 'selectAll', 'item']

  declare readonly selectAllTarget: HTMLInputElement
  declare readonly itemTargets: HTMLInputElement[]
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly contentTarget: HTMLElement

  connect (): void {
    this.attachCheckboxListeners()
    this.updateButtonLabel(this.isContentVisible)
  }

  buttonTargetConnected (_el: HTMLButtonElement): void {
    this.updateButtonLabel(this.isContentVisible)
  }

  toggle (event: Event): void {
    event.preventDefault()
    this.toggleVisibility()
  }

  private get isContentVisible (): boolean {
    return !this.contentTarget.classList.contains('hidden')
  }

  private showContent (): void {
    this.contentTarget.classList.remove('hidden')
    this.updateButtonLabel(true)
  }

  private hideContent (): void {
    this.contentTarget.classList.add('hidden')
    this.updateButtonLabel(false)
  }

  private toggleVisibility (): void {
    this.isContentVisible ? this.hideContent() : this.showContent()
  }

  private updateButtonLabel (visible: boolean): void {
    const count = this.currentCount
    this.buttonTarget.textContent = visible ? 'Hide results' : `Show ${count} results`
  }

  private get currentCount (): number {
    return Number(this.buttonTarget.dataset.toggleEvidenceResultsCountValue ?? 0)
  }

  attachCheckboxListeners (): void {
    const selectAll = this.element.querySelector<HTMLInputElement>(
      "[data-toggle-evidence-results-target='selectAll']"
    )
    const items = Array.from(
      this.element.querySelectorAll<HTMLInputElement>(
        "[data-toggle-evidence-results-target='item']"
      )
    )

    if ((selectAll == null) || items.length === 0) return

    const newSelectAll = selectAll.cloneNode(true) as HTMLInputElement
    selectAll.replaceWith(newSelectAll)

    const newItems = items.map(item => {
      const clone = item.cloneNode(true) as HTMLInputElement
      item.replaceWith(clone)
      return clone
    })

    newSelectAll.addEventListener('change', () => {
      newItems.forEach(item => (item.checked = newSelectAll.checked))
    })

    newItems.forEach(item => {
      item.addEventListener('change', () => {
        newSelectAll.checked = newItems.every(i => i.checked)
      })
    })
  }
}
